
import PricingPlan from "./Components/Pricing"
import './App.css';
import { CircleArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import logo from "../src/botgurulogo.png";
import { useAuthContext } from "./Components/Auth/AuthContext";

export const ChoosePlan=()=>{
    const navigate= useNavigate();
    const {theme} = useAuthContext();
    return (
        <div className="ChoosePlan-container">
            <>
            {
                theme ==="light" ? <img className='botguru-logo-image-pricing'src="/botGuruBlackLogo.svg" alt="Logo" onClick={()=>navigate("/")} />
                : <img className='botguru-logo-image-pricing'src={logo} alt="Logo" onClick={()=>navigate("/")} />
            }

            {/* <img className='botguru-logo-image-pricing'src={logo} alt="Logo" onClick={()=>navigate("/")} /> */}
                <button className="skip-subscription"
                    onClick={() => navigate("/landingPage")} >
                    Dashboard
                    <CircleArrowRight />
                </button>
            </>
            <PricingPlan />
        </div>
    )
}